import React, { useEffect, useRef } from 'react';
import MaterialTable, { MTableToolbar } from 'material-table';
import { forwardRef } from 'react';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import CloudQueueIcon from '@material-ui/icons/CloudQueue';
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationCircle, faCl, faFile, faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons'
import { TablePagination } from '@material-ui/core';
import { Tooltip } from '@material-ui/core';
import Cookies from 'js-cookie';
import API_PATH from "../../constants/config.json";
import TextField from '@material-ui/core/TextField';
import SearchIcon from '@material-ui/icons/Search';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import InputAdornment from '@material-ui/core/InputAdornment';
import { clearCookie, setCookie } from '../../functions/Auth';
import { useHistory } from 'react-router-dom';
import { NavLink } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import InfoIcon from '@material-ui/icons/Info';
import { Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;
const AWS = require('aws-sdk');

//Start Css Code ...
const useStyles = makeStyles((theme) => ({
    filterTable: {
        '@media only screen and (min-width: 3501px)': {
            marginTop: '35px',
        },
        '& .MuiTableCell-head': {
            fontWeight: '600',
            fontSize: '14pt',
            background: '#fff',
            color: '#333',
            border: '1px solid #d1d1d1',
            padding: '5px',

        },
        '& .MuiCheckbox-root': {
            padding: '0px',
        },
        '& .MuiCheckbox-colorSecondary.Mui-checked': {
            color: '#3f51b5',
        },
        '& .MuiCheckbox-indeterminate.MuiIconButton-colorSecondary': {
            color: '#3f51b5',
        },
        '& .MuiFormControl-root': {
            border: '1px solid #24618E',
            borderRadius: '3px 3px 3px 3px',
            paddingLeft: '0px',
            position: 'absolute',
            padding: ' 0px 6px 0px 0px',
            top: '15px',
            zIndex: 1,
            '@media only screen and (max-width: 3500px)': {
                width: '400px',
            },
            '@media only screen and (min-width: 3501px)': {
                width: '650px',
                '& input': {
                    fontSize: '24pt',                    
                }
            },
            '& .MuiIconButton-root.Mui-disabled': {
                color: '#fff',
            },
            '& :hover .MuiInputAdornment-positionEnd button': {
                color: '#24618E !important',
                fontWeight: '600 !important',
            },
        },
        '& .MuiInput-underline:before': {
            borderBottom: 'none !important',
        },
        '& .MuiInputAdornment-positionStart': {
            background: '#24618E',
            color: '#fff',
            paddingLeft: '5px',
            borderRadius: '0px 3px 3px 0px',
            position: 'relative',
            left: '100%',
            '@media only screen and (max-width: 3500px)': {
                height: '32px',
                width: '43px',
            },
            '@media only screen and (min-width: 3501px)': {
                height: '60px',
                width: '70px',
                maxHeight:'60px',
                marginLeft:'-28px',
            },
        },
        '& .MuiToolbar-root ': {
            paddingLeft: '0px',
            minHeight: '48px',
        },
        '& .MuiInput-root': {
            left: '-30px',
        },
        '& .MuiInputAdornment-positionStart svg': {
            '@media only screen and (max-width: 3500px)': {
                fontSize: '31px !important',
            },
            '@media only screen and (min-width: 3501px)': {
                fontSize: '50px !important',
                marginLeft: '5px',
            },
        },
        '& td': {
            padding: '5px !important',
            border: '1px solid #D7D7D7',
            '@media only screen and (max-width: 3500px)': {
                fontSize: '12pt !important',
            },
            '@media only screen and (min-width: 3501px)': {
                fontSize: '24pt !important',
            },
        },
        '& th': {
            border: '1px solid #D7D7D7',
            '@media only screen and (max-width: 3500px)': {
                fontSize: '12pt !important',
                padding: '5px !important',
            },
            '@media only screen and (min-width: 3501px)': {
                fontSize: '24pt !important',
                padding: '5px !important',
            },
            '& span': {
                '@media only screen and (max-width: 3500px)': {
                    fontSize: '12pt !important',
                },
                '@media only screen and (min-width: 3501px)': {
                    fontSize: '24pt !important',
                },
            }
        },
        '& svg': {
            '@media only screen and (min-width: 3501px)': {
                fontSize: '30pt !important',
            },
        },
        '& tr:nth-child(odd)': {
            backgroundColor: '#f2f2f2'
        },
        '& table': {
            borderRight: '1px solid #D7D7D7',
        },
        '& .MuiTableCell-head:nth-child(2)': {
            textAlign: 'left',
        },
        '& .MuiTableCell-body:nth-child(2)': {
            textAlign: 'left',
        },
        '& .MuiTablePagination-select': {
            color: '#000',
        },
    },
    tdLink: {
        color: '#24618E',
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        }
    },
    // margin: {
    //     padding: '2px 2px 2px 2px'
    // },
    statusApprove: {
        margin: '0px',
        textAlign: 'left',
        '& .statusIcon': {
            color: '#00A75D',
            paddingRight: '5px',
            position: 'relative',
            top: '2px',
        },
        '& .statusText': {
            color: '#006600',
        }
    },
    errorStatus: {
        margin: '0px',
        textAlign: 'left',
        '& .statusIcon': {
            color: '#CC0000',
            paddingRight: '5px',
            position: 'relative',
            top: '2px',
        },
        '& .statusText': {
            color: '#CC0000',
        }
    },
    btbBlock: {
        paddingTop: '20px',
        '& #rejected_btn': {
            color: '#CC0000',
            border: '1px solid #333',
            background: '#fff',
            width: '200px',
            '&:hover': {
                boxShadow: '4px 3px 3px 0px #999',
            }
        },
        '& #approved_btn': {
            color: '#fff',
            background: '#24618E',
            border: '1px solid #24618E',
            width: '200px',
            '&:hover': {
                boxShadow: '4px 3px 3px 0px #999',
            }
        }
    },
    actionLike: {
        color: "#d7d7d7",
        "&:hover": {
            color: "#00A75D"
        }
    },
    actionDislike: {
        color: "#d7d7d7",
        "&:hover": {
            color: "#CC0000"
        }
    },
    actionLikeapprovebtn: {
        width: '50%',
        float: 'left',
        textAlign: 'center',
    },
    actionDisLikeNotApprovebtn: {
        width: '50%',
        float: 'right',
        textAlign: 'center',
    },
    crossCursor: {
        color: '#24618d',
        fontSize: '14pt',
        fontFamily: 'Avenir_Black',
        fontWeight: '800',
        position: 'absolute',
        width: '30px !important',
        right: '0px',
        cursor: 'pointer'
    },
    crossIcon: {
        color: '#24618d',
        fontSize: '20pt',
        fontFamily: 'Avenir_Black',
        fontWeight: '800',
        position: 'absolute',
        width: '40px !important',
        right: '5px',
        "&:hover": {
            // color: "#CC0000",
            cursor: 'pointer',
        }
    },
    loaderClass: {
        '& .MuiCircularProgress-root': {
            width: '20px !important',
            height: '15px !important',
            color: '#24618E',
            marginLeft: '30px !important',
            marginTop: '13px !important'
        }
    },
    listLink: {
        textDecoration: 'none',
    }
}));
//End Css Code ...

//Start ImportList component code ..
const ImportList = props => {
    let history = useHistory();
    const classes = useStyles();

    const [fileList, setFileList] = React.useState([]);
    const [pagination, setPagnation] = React.useState({ selectedPage: 1 });
    const [totalItems, setTotalItems] = React.useState(0);
    const [hover, setHower] = React.useState(false);
    const [getSearchTerm, setSearchTerm] = React.useState("");
    const [loader, setloader] = React.useState({ filename: "", loader: false });
    const [idintityPool, setIdintityPool] = React.useState('');
    const [aswLogins, setAswLogins] = React.useState('');
    const [errorDialogue, setErrorDialogue] = React.useState(false);
    const [getLoader, setLoaderDisable] = React.useState(false);
    const refContainer = useRef('');
    let enteriesPerPage = 25;
    let values = {
        "pageNo": pagination.selectedPage,
        "entriesPerPage": enteriesPerPage,
    }

    useEffect(
        () => {
            getFilesAPI();
            getAswToken();
        }, []
    )

    const handleCloseDialogueBox = () => {
        setErrorDialogue(false);
    }

    const handleOpenDialogueBox = () => {
        setErrorDialogue(true);
    }
 
    //This method is use for API call to get all files .... Start
    const getFilesAPI = (page = 1, search = "", enable = false) => {
        setLoaderDisable(true);
        try {
            axios({
                method: 'post',
                data: {
                    pageNo: page,
                    entriesPerPage: enteriesPerPage,
                    searchEnable: enable,
                    searchValue: search
                },
                headers: {
                    'payload': Cookies.get('payload'),
                    'agencyid': sessionStorage.getItem('agency_id')
                },
                url: API_URL + API_PATH.getImportFilesAPI,
            })
                .then(async function (response) {
                    if (response.status && response.status == '200') {
                        let fileData = response.data.data.rows;
                        setLoaderDisable(false);                      
                        setFileList(fileData);
                        setTotalItems(response.data.data.count);
                    } else {
                        setFileList([]);
                        setLoaderDisable(false);
                    }
                })
                .catch(async function (error) {
                    setLoaderDisable(false);
                    if (error.response) {
                        if (error.response.status == '401') {
                            if (Cookies.get('email')) {
                                clearCookie('email');
                                clearCookie('payload');
                                clearCookie('idToken');
                                clearCookie('organization');
                                clearCookie('atexpiry');
                            }
                            history.push('/');
                        }
                    }
                })
        } catch (error) {
            console.error(error);
            setLoaderDisable(false);
        }
    }
    //This method is use for API call to get all files .... End


    //This method is use for API call to get all approved files .... start
    const getFilesAfterApproved = (page = 1, search = "", enable = false) => {
         try {
            axios({
                method: 'post',
                data: {
                    pageNo: page,
                    entriesPerPage: enteriesPerPage,
                    searchEnable: enable,
                    searchValue: search
                },
                headers: {
                    'payload': Cookies.get('payload'),
                    'agencyid': sessionStorage.getItem('agency_id')
                },
                url: API_URL + API_PATH.getImportFilesAPI,
            })
                .then(async function (response) {
                    if (response.status && response.status == '200') {
                        let fileData = response.data.data.rows;
                        setLoaderDisable(false);                        
                        setFileList(fileData);
                        setTotalItems(response.data.data.count);
                    } else {
                        setFileList([]);
                        setLoaderDisable(false);
                    }
                })
                .catch(async function (error) {
                    setLoaderDisable(false);
                    if (error.response) {
                        if (error.response.status == '401') {
                            if (Cookies.get('email')) {
                                clearCookie('email');
                                clearCookie('payload');
                                clearCookie('idToken');
                                clearCookie('organization');
                                clearCookie('atexpiry');
                            }
                            history.push('/');
                        }
                    }
                })
        } catch (error) {
            console.error(error);
            setLoaderDisable(false);
        }
    }
    //This method is use for API call to get all approved files .... end

    //This method is use to changed file status .... Start
    const changeFileStatus = (fileId, status, selectedPage) => {
        try {
            axios({
                method: 'post',
                data: {
                    file_id: fileId,
                    statusId: status
                },
                headers: {
                    'payload': Cookies.get('payload'),
                    'agencyid': sessionStorage.getItem('agency_id')
                },
                url: API_URL + API_PATH.changeFileStatusAPI,
            })
                .then(async function (response) {
                    getFilesAfterApproved(pagination.selectedPage);
                })
                .catch(async function (error) {
                    if (error.response) {
                        if (error.response.status == '401') {
                            if (Cookies.get('email')) {
                                clearCookie('email');
                                clearCookie('payload');
                                clearCookie('idToken');
                                clearCookie('organization');
                                clearCookie('atexpiry');
                            }
                            history.push('/');
                        }
                    }
                })
        } catch (error) {
            console.error(error);
        }
    }
    //This method is use to changed file status .... End
   
    const handleSelected = (e, selectedPage) => {
        if (getSearchTerm != '') {
            let page = selectedPage + 1;
            values.pageNo = selectedPage + 1;
            setPagnation({ selectedPage: selectedPage + 1 })
            getFilesAPI(page, getSearchTerm, true)
        } else {
            let page = selectedPage + 1;
            values.pageNo = selectedPage + 1;
            setPagnation({ selectedPage: selectedPage + 1 })
            getFilesAPI(page);
        }
    }


    const changeRows = (e) => {
        enteriesPerPage = e.target.value;
    }

    const searchField = (e) => {
        setHower(true)
        setSearchTerm(e.target.value);        
        getFilesAPI(1, e.target.value, true)
        setPagnation({ selectedPage: 1 })
    }

    const onSearch = () => {
        getFilesAPI(1, getSearchTerm, true)
        setPagnation({ selectedPage: 1 })
    }

    const clearText = () => {
        refContainer.current.reset();
        setSearchTerm('');
        getFilesAPI();
    }

    //This method is use for get aws token for file download .... Start
    const getAswToken = () => {
        try {
            axios({
                method: 'get',
                url: API_URL + API_PATH.getAWSs3TokenAPI,
                headers: {
                    'agencyid': sessionStorage.getItem('agency_id'),
                    'payload': Cookies.get('payload'),
                },
            }).then(async function (response) {
                if (response.status && response.status == '200') {
                    let aswData = response.data;
                    setIdintityPool(aswData.data.IdentityPoolId);
                    setAswLogins(aswData.data.Logins);
                } else {
                    console.log("Do Not Get Any Station ID");
                }
            })
        } catch (error) {
            console.error(error);
        }
    }
    //This method is use for get aws token for file download .... End

    //This method is use for download file from s3 bucket .... Start
    const downloadFile = (file_id, bucketName, filename, originalFileName) => {
        setloader({ filename: file_id, loader: true });
        let OIDToken = Cookies.get('idToken');
        AWS.config.update(
            {
                region: 'us-west-2',
                credentials: new AWS.CognitoIdentityCredentials({
                    IdentityPoolId: idintityPool,
                    Logins: {
                        [aswLogins]: OIDToken
                    }
                })
            }
        );
        let s3 = new AWS.S3();
        s3.getObject({ Bucket: bucketName, Key: filename }, function (
            error,
            data
        ) {
            if (error != null) {
                console.log(error)
                handleOpenDialogueBox();
                loader.loader = false
                setloader(loader);
            } else {
                let blob = new Blob([data.Body], { type: data.ContentType });
                let link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = originalFileName;
                link.click();
                loader.loader = false
                setloader(loader);
            }
        });
    };
     //This method is use for download file from s3 bucket .... end

    const goToStationDetails = (id, type, client_station_id) => {
        if (type == 'Intersection') {               
            window.open('/intersection_details?station=' + client_station_id, '_blank');
        } else if (type == 'Midblock') {             
            window.open('/midblock_details?station=' + client_station_id, '_blank');
        }
    }

   
    let actionLikebtn = <><div className={classes.actionLikeapprovebtn}><FontAwesomeIcon icon={faThumbsUp} className={classes.actionLike} /></div><div className={classes.actionDisLikeNotApprovebtn}><FontAwesomeIcon icon={faThumbsDown} className={classes.actionDislike} /></div></>;



    const tableIcons = {
        Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
        Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
        Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
        Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
        DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
        Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
        Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
        Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
        FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
        LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
        NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
        PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
        ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
        Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
        SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
        ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
        ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
        Like: forwardRef((props, ref) => <FontAwesomeIcon icon={faThumbsUp} className={classes.actionLike} {...props} ref={ref} />),
        Dislike: forwardRef((props, ref) => <FontAwesomeIcon icon={faThumbsDown} className={classes.actionDislike} {...props} ref={ref} />)
    };


    return (
        <div className={classes.filterTable}>

            <form className={classes.rootForm} noValidate autoComplete="off">

                <form ref={refContainer} noValidate autoComplete="off">
                    <TextField
                        id="input-with-icon-textfield"
                        placeholder="Search"
                        onChange={(e) => searchField(e)}
                        onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start" onClick={onSearch}>
                                    <SearchIcon style={{ cursor: 'pointer' }} />
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    {hover && <FontAwesomeIcon icon={faTimes} className={classes.crossCursor} onClick={clearText} />}
                                </InputAdornment>
                            ),
                        }}

                    />
                </form>

                <Dialog
                    open={errorDialogue}
                    onClose={handleCloseDialogueBox}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    className={classes.deletePopup}
                >
                    <DialogTitle id="alert-dialog-title" style={{ borderBottom: "1px solid #00A75D", marginRight: '15px', marginLeft: '15px', padding: '7px 0px 0px 21px' }}>
                        <Typography component={"h4"} className={classes.header} style={{ marginLeft: "-20px" }}>
                            Error
                <FontAwesomeIcon icon={faTimes} className={classes.crossIcon} onClick={handleCloseDialogueBox} />

                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        <Typography className={classes.errorMsg} >
                            <InfoIcon style={{ color: '#CC0000', marginBottom: '-6px' }} /> File Downloading Failed!
                </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseDialogueBox} className={classes.clearBtn} style={{ border: "1px solid #24618E", borderRadius: '5px', marginBottom: "10px" }}>
                            Ok
                </Button>
                    </DialogActions>
                </Dialog>

                <MaterialTable
                    icons={tableIcons}
                    title=""
                    columns={[
                        {
                            title: 'Actions', field: 'actions', cellStyle: {
                                width: '5%',
                            },
                            headerStyle: {
                                width: '5%',
                                textAlign: 'center',
                                fontWeight: '600'
                            },
                            render: rowData => {
                                if (rowData.status == 'Ready') {
                                    return <><span title='Approve' style={{ cursor: 'pointer' }}><div className={classes.actionLikeapprovebtn}><FontAwesomeIcon icon={faThumbsUp} className={classes.actionLike} onClick={() => changeFileStatus(rowData.file_id, 3)} /></div></span><span title='Reject' style={{ cursor: 'pointer' }}><div className={classes.actionDisLikeNotApprovebtn}><FontAwesomeIcon icon={faThumbsDown} className={classes.actionDislike} onClick={() => changeFileStatus(rowData.file_id, 5)} /></div></span></>
                                } else if (rowData.status == 'Approved') {
                                    return <><span title='Reject' style={{ cursor: 'pointer' }}><div className={classes.actionDisLikeNotApprovebtn}><FontAwesomeIcon icon={faThumbsDown} className={classes.actionDislike} onClick={() => changeFileStatus(rowData.file_id, 5)} /></div></span></>
                                }
                            }
                        },
                        {
                            title: 'Batch Number', field: 'batch_number', cellStyle: {
                                width: '10%',
                            },
                            headerStyle: {
                                width: '10%',
                                textAlign: 'center',
                                fontWeight: '600'
                            },
                        },
                        {
                            title: 'Date', field: 'createdAt', cellStyle: {
                                width: '8%',
                                textAlign: 'center',
                            },
                            headerStyle: {
                                width: '8%',
                                textAlign: 'center',
                            },
                            render: rowData => {
                                var d = new Date(rowData.createdAt);                               
                                return d.toLocaleString("en-US", { month: '2-digit', day: '2-digit', year: 'numeric' });
                            },
                        },
                        {
                            title: 'Status', field: 'status', cellStyle: {
                                width: '12%',
                            },
                            headerStyle: {
                                width: '12%',
                                textAlign: 'center',
                            },
                            render: rowData => rowData.status == 'Approved' ? <p className={classes.statusApprove}><span className="statusIcon" style={{ cursor: 'pointer' }} title='Approved'><FontAwesomeIcon icon={faCheckCircle} /></span><span className="statusText">Approved</span></p> : rowData.status == 'Error' ? <p className={classes.errorStatus}><span className="statusIcon" style={{ cursor: 'pointer' }} title={rowData.error_message}><FontAwesomeIcon icon={faExclamationCircle} /></span><span className="statusText">Error</span></p> : rowData.status,
                        },
                        {
                            title: 'Station ID', field: 'client_station_id', cellStyle: {
                                width: '10%',
                            },
                            headerStyle: {
                                width: '10%',
                                textAlign: 'center',
                            },
                            render: rowData => <NavLink to="#" onClick={() => goToStationDetails(rowData.station_id, rowData.stationtype, rowData.client_station_id)} className={classes.tdLink} >{rowData.client_station_id}</NavLink>,
                        },
                        {
                            title: 'File Name', field: 'filename', cellStyle: {
                                width: '28%',
                            },
                            headerStyle: {
                                width: '28%',
                                textAlign: 'center',
                            },
                            render: rowData => <NavLink to="#" onClick={() => downloadFile(rowData.file_id, rowData.bucket_name, rowData.base_name, rowData.filename)} className={classes.tdLink} >{rowData.filename}<span className={classes.loaderClass}>{loader.filename === rowData.file_id && loader.loader ? <CircularProgress /> : null}</span></NavLink>,
                        },
                        {
                            title: <span title='Data import availability' style={{ cursor: 'pointer' }}><CloudQueueIcon /></span>, field: 'file_type', sorting: false, cellStyle: {
                                width: '3%',
                                textAlign: 'center',
                            },
                            headerStyle: {
                                width: '3%',
                                textAlign: 'center',
                            },
                            render: rowData => rowData.file_type_id === 5 ? <span title='Data import not supported' style={{ cursor: 'pointer' }}><InsertDriveFileOutlinedIcon /></span> : <span title='Data import available' style={{ cursor: 'pointer' }}><CloudQueueIcon /></span>,
                        },
                        {
                            title: 'Imported By', field: 'email', cellStyle: {
                                width: '25%',
                            },
                            headerStyle: {
                                width: '25%',
                                textAlign: 'center',
                            }
                        },
                    ]}
                    data={fileList}
                    options={{
                        thirdSortClick: false,
                        filtering: false,
                        search: false,
                        sorting: true,
                        pageSize: enteriesPerPage,
                        paging: true,
                        pageSizeOptions: [0],
                        emptyRowsWhenPaging: false,
                        maxBodyHeight: sessionStorage.getItem('dmTabWidth') >= 3501 ? (sessionStorage.getItem('dmTabHeight') - 450).toString() + 'px' : (sessionStorage.getItem('dmTabHeight') - 320).toString() + 'px'
                       }}
                   
                    components={                       
                        getLoader == false ?
                            {
                                Pagination: props => (
                                    <TablePagination
                                        {...props}
                                        count={totalItems}
                                        page={pagination.selectedPage - 1}
                                        onChangePage={handleSelected}
                                        rowsPerPage={enteriesPerPage}
                                        onChangeRowsPerPage={changeRows}
                                    />
                                )
                            }
                            :
                            {
                                Pagination: props => (
                                    <TablePagination
                                        {...props}
                                        count={totalItems}
                                        page={pagination.selectedPage - 1}
                                        onChangePage={handleSelected}
                                        rowsPerPage={enteriesPerPage}
                                    />
                                ),
                                Body: (props) => (
                                    <tbody><tr style={{ height: '49px' }}><td colspan="9" style={{ paddingTop: '0px', paddingBottom: '0px', textAlign: 'center' }}><span style={{ color: '#CC0000', fontWeight: '600' }}><CircularProgress /></span> </td></tr></tbody>
                                )
                            }
                    }
                />

            </form>
        </div>
    )
}

export default ImportList;
//End ImportList component code ..

